/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/**
 * ExistingCustomerForm.jsx
 * Created by Hassan Riaz on 1/16/20.
 */

import React from 'react';
import PropTypes from 'prop-types';

import {
    Button,
    FlexCol,
    FlexRow,
    Notification,
    Select,
    SelectOption,
    TextField,
} from 'sarsaparilla';

export default class ExistingCustomerForm extends React.PureComponent {
    static propTypes = {
        search: PropTypes.func,
        error: PropTypes.string,
    };

    constructor(props) {
        super(props);

        this.state = {
            searchType: 'email',
            searchTerm: '',
        };
    }

    handleSearchTypeChange = (e) => {
        const searchType = e.target.value;
        this.setState({ searchType });
    };

    handleSearchTermChange = (e) => {
        const searchTerm = e.target.value;
        this.setState({ searchTerm });
    };

    search = (e) => {
        e.preventDefault();
        this.props.search(this.state.searchType, this.state.searchTerm);
    };

    render() {
        let error = null;
        if (this.props.error) {
            error = (
                <div className="mb-2">
                    <Notification type="error">{this.props.error}</Notification>
                </div>
            );
        }

        return (
            <form onSubmit={this.search}>
                {error}
                <FlexRow alignItems="end">
                    <FlexCol>
                        <Select
                            id="search-type"
                            label="Search Type"
                            value={this.state.searchType}
                            onChange={this.handleSearchTypeChange}
                            placeholder="Choose an option"
                        >
                            <SelectOption value="email">Email</SelectOption>
                            <SelectOption value="phone">Phone</SelectOption>
                        </Select>
                    </FlexCol>
                    <FlexCol xs={8}>
                        <TextField
                            id="search-term"
                            label="Search Term"
                            value={this.state.searchTerm}
                            onChange={this.handleSearchTermChange}
                            hasClearButton
                        />
                    </FlexCol>
                    <FlexCol>
                        <Button type="submit">Search</Button>
                    </FlexCol>
                </FlexRow>
            </form>
        );
    }
}
